import { OIDC_TENANTS, SSO_SCOPE } from './envConstants';

// client_secret / client_assertion values are secrets — they stay in process.env
// (injected by pipeline). All client IDs and authority URLs are non-secret and
// come from OIDC_TENANTS in envConstants.js.

export const oidcConfigData = () => {
	const subdomain = window.location.host.split('.')[0];
	const origin = window.location.origin;
	const redirectUri = `${origin}/secretlogin`;
	const silentRedirectUri = `${origin}/secretlogin`;
	const postLogoutRedirectUri = `${origin}/logout`;

	if (origin.indexOf('localhost') >= 0) {
		const t = OIDC_TENANTS.localhost;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	} else if (subdomain === 'dev') {
		const t = OIDC_TENANTS.dev;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	} else if (subdomain === 'qa') {
		const t = OIDC_TENANTS.qa;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	} else if (subdomain === 'uat') {
		const t = OIDC_TENANTS.uat;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	} else if (subdomain === 'googletest') {
		const t = OIDC_TENANTS.googletest;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			client_secret: process.env.REACT_APP_SECRET_KEY_GOOGLETEST,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	} else if (subdomain === 'infoprolearning') {
		const t = OIDC_TENANTS.infoprolearning;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	} else if (subdomain === 'innovant') {
		const t = OIDC_TENANTS.innovant;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			client_secret: process.env.REACT_APP_SECRET_KEY_INNOVANT,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	} else if (subdomain === 'compunnel') {
		const t = OIDC_TENANTS.compunnel;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			post_logout_redirect_uri: postLogoutRedirectUri,
			client_assertion: process.env.REACT_APP_SECRET_KEY_COMPUNNEL,
		};
	} else {
		const t = OIDC_TENANTS.infoprolearning;
		return {
			client_id: t.client_id,
			redirect_uri: redirectUri,
			silent_redirect_uri: silentRedirectUri,
			scope: SSO_SCOPE,
			authority: t.authority,
			post_logout_redirect_uri: postLogoutRedirectUri,
		};
	}
};
